<template>
    <div class="wrapper">
        <div v-if="images && images.length === 1" class="image">
            <img :src="images[0].image" alt="img" />
        </div>
        <div
            v-if="images && images.length === 2"
            class="image-grid-columns"
        >
            <div class="column" v-for="(img, index) in images" :key="index">
                <img :src="img.image" alt="alt" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "image-grid",

    props: ["images"]
};
</script>

<style lang="scss" scoped>
.wrapper {
    max-width: 100%;
    padding: 1em 0;

    &.approach-image-grid {
        width: 100%;
    }
}

.image {
    position: relative;

    &::before {
        content: "";
        display: block;
        padding-bottom: 70%;
        background: var(--black);
    }

    img {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.image-grid-columns {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--padding);

    .column {
        position: relative;

        img {
            display: block;
            max-width: 100%;
            width: 100%;
            margin: auto;
            height: auto;
        }
    }
}

@media only screen and (min-width: 767px) {
    .image-grid-columns {
        flex-direction: row;

        .column {
            width: 50%;
        }
    }
}
</style>
